import React, { Component } from "react";

export const DownwardIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      id="icon-arrow_drop_down"
      viewBox="0 0 20 20"
      width={width}
      height={height}
    >
      <title>expand</title>
      <path d="M6.984 9.984h10.031l-5.016 5.016z"></path>
    </svg>
  );
};

export const UpwardIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      id="icon-arrow_drop_up"
      viewBox="0 0 20 20"
      width={width}
      height={height}
    >
      <path d="M6.984 14.016l5.016-5.016 5.016 5.016h-10.031z"></path>
    </svg>
  );
};

export const MenuIcon = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg id="icon-menu" viewBox="0 0 20 20" width={width} height={height}>
      <title>menu</title>
      <path d="M16.4 9h-12.8c-0.552 0-0.6 0.447-0.6 1s0.048 1 0.6 1h12.8c0.552 0 0.6-0.447 0.6-1s-0.048-1-0.6-1zM16.4 13h-12.8c-0.552 0-0.6 0.447-0.6 1s0.048 1 0.6 1h12.8c0.552 0 0.6-0.447 0.6-1s-0.048-1-0.6-1zM3.6 7h12.8c0.552 0 0.6-0.447 0.6-1s-0.048-1-0.6-1h-12.8c-0.552 0-0.6 0.447-0.6 1s0.048 1 0.6 1z"></path>
    </svg>
  );
};

export const MenuIcon2 = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-align-left"
    >
      <line x1="21" x2="3" y1="6" y2="6" />
      <line x1="15" x2="3" y1="12" y2="12" />
      <line x1="17" x2="3" y1="18" y2="18" />
    </svg>
  );
};

export const AssignUserIcon = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg id="icon-bin" viewBox="0 0 32 32" width={width} height={height}>
      <title>Assign</title>
      <path d="M12,26.65a2.8,2.8,0,0,1,4.85-1.8L20.71,29l6.84-7.63A16.81,16.81,0,0,0,18,18.55,16.13,16.13,0,0,0,5.5,24a1,1,0,0,0-.2.61V30a2,2,0,0,0,1.94,2h8.57l-3.07-3.3A2.81,2.81,0,0,1,12,26.65Z"></path>
    </svg>
  );
};

export const DustbinIcon = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg id="icon-bin" viewBox="0 0 32 32" width={width} height={height}>
      <path d="M4 10v20c0 1.1 0.9 2 2 2h18c1.1 0 2-0.9 2-2v-20h-22zM10 28h-2v-14h2v14zM14 28h-2v-14h2v14zM18 28h-2v-14h2v14zM22 28h-2v-14h2v14z"></path>
      <path d="M26.5 4h-6.5v-2.5c0-0.825-0.675-1.5-1.5-1.5h-7c-0.825 0-1.5 0.675-1.5 1.5v2.5h-6.5c-0.825 0-1.5 0.675-1.5 1.5v2.5h26v-2.5c0-0.825-0.675-1.5-1.5-1.5zM18 4h-6v-1.975h6v1.975z"></path>
    </svg>
  );
};

export const LogoIcon = (props) => {
  const { width = 32, height = 32 } = props;

  return (
    <svg id="icon-earth" viewBox="0 0 32 32" width={width} height={height}>
      <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 30c-1.967 0-3.84-0.407-5.538-1.139l7.286-8.197c0.163-0.183 0.253-0.419 0.253-0.664v-3c0-0.552-0.448-1-1-1-3.531 0-7.256-3.671-7.293-3.707-0.188-0.188-0.442-0.293-0.707-0.293h-4c-0.552 0-1 0.448-1 1v6c0 0.379 0.214 0.725 0.553 0.894l3.447 1.724v5.871c-3.627-2.53-6-6.732-6-11.489 0-2.147 0.484-4.181 1.348-6h3.652c0.265 0 0.52-0.105 0.707-0.293l4-4c0.188-0.188 0.293-0.442 0.293-0.707v-2.419c1.268-0.377 2.61-0.581 4-0.581 2.2 0 4.281 0.508 6.134 1.412-0.13 0.109-0.256 0.224-0.376 0.345-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.139 1.139 2.663 1.758 4.239 1.758 0.099 0 0.198-0.002 0.297-0.007 0.432 1.619 1.211 5.833-0.263 11.635-0.014 0.055-0.022 0.109-0.026 0.163-2.541 2.596-6.084 4.208-10.004 4.208z"></path>
    </svg>
  );
};

export const DropIcon = (props) => {
  const { message = "Heartbeat", width = 32, height = 32 } = props;
  return (
    <svg id="icon-drop" viewBox="0 0 20 20" width={width} height={height}>
      <title>drop</title>
      <path d="M10.203 0.561c-0.027-0.215-0.38-0.215-0.406 0-0.883 7.107-5.398 8.572-5.398 13.512 0 3.053 2.564 5.527 5.601 5.527s5.6-2.475 5.6-5.527c0-4.94-4.514-6.405-5.397-13.512zM9.35 8.418c-0.059 0.219-0.123 0.444-0.189 0.678-0.401 1.424-0.856 3.039-0.856 4.906 0 1.012-0.598 1.371-1.156 1.371-0.639 0-1.156-0.523-1.156-1.166 0-2.207 1.062-3.649 2-4.92 0.295-0.398 0.572-0.775 0.797-1.15 0.103-0.172 0.38-0.164 0.506 0.006 0.059 0.080 0.079 0.182 0.054 0.275z"></path>
    </svg>
  );
};

export const EnlargeIcon = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg id="icon-enlarge" viewBox="0 0 32 32" width={width} height={height}>
      <title>enlarge</title>
      <path d="M32 32v-13l-5 5-6-6-3 3 6 6-5 5z"></path>
      <path d="M0 0v13l5-5 6 6 3-3-6-6 5-5z"></path>
    </svg>
  );
};

export const HeartIcon = (props) => {
  const { message = "Heartbeat", width = 32, height = 32 } = props;
  return (
    <svg id="icon-heart" viewBox="0 0 40 40" width={width} height={height}>
      <title>{message}</title>
      <g transform="translate(20 20)">
        <path
          transform="translate(-10 -10)"
          d="M17.19 4.155c-1.672-1.534-4.383-1.534-6.055 0l-1.135 1.042-1.136-1.042c-1.672-1.534-4.382-1.534-6.054 0-1.881 1.727-1.881 4.52 0 6.246l7.19 6.599 7.19-6.599c1.88-1.726 1.88-4.52 0-6.246z"
        ></path>
        <animateTransform
          attributeName="transform"
          type="scale"
          values="1; 1.5; 1.25; 1.5; 1.5; 1;"
          dur="1s"
          repeatCount="indefinite"
          additive="sum"
        ></animateTransform>
      </g>
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg id="icon-cross" viewBox="0 0 512 512">
      <title>cross</title>
      {/* <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path> */}
      <path
        d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
        fill="grey"
      />
      <path
        d="m350.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0"
        fill="#fafafa"
      />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg id="icon-calendar" viewBox="0 0 20 20">
      <title>calendar</title>
      <path d="M17 3h-1v2h-3v-2h-6v2h-3v-2h-1c-1.101 0-2 0.9-2 2v12c0 1.1 0.899 2 2 2h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM17 17h-14v-8h14v8zM6.5 1h-2v3.5h2v-3.5zM15.5 1h-2v3.5h2v-3.5z"></path>
    </svg>
  );
};

export const BookmarkIcon = (props) => {
  return (
    <svg id="icon-bookmark" viewBox="0 0 20 20">
      <title>bookmark</title>
      <path d="M14 2v17l-4-4-4 4v-17c0-0.553 0.585-1.020 1-1h6c0.689-0.020 1 0.447 1 1z"></path>
    </svg>
  );
};

export const LocationPin = (props) => {
  return (
    <svg viewBox="0 0 20 20" id="location-pin">
      <title>location-pin</title>
      <path d="M10 2.009c-2.762 0-5 2.229-5 4.99 0 4.774 5 11 5 11s5-6.227 5-11c0-2.76-2.238-4.99-5-4.99zm0 7.751a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4z"></path>
    </svg>
  );
};

export const EarthIcon = (props) => {
  return (
    <svg id="icon-earth" viewBox="0 0 512 512">
      <title>earth</title>
      <g>
        <path
          fill="#03AA6F"
          d="M441.374,79.519l-26.485,17.656l-44.141-8.828l-26.485-8.828l-35.313,8.828l-26.485-8.828   l17.656-35.313h35.313l34.607-17.303C396.73,40.101,420.875,57.916,441.374,79.519z"
        />
        <path
          fill="#03AA6F"
          d="M238.325,44.206l-8.828,26.485l-26.485,8.828l-26.485,44.141l-44.141,26.485l-61.797,8.828v26.485   l17.656,17.656v35.313L61.762,220.77l-26.485-17.656l-15.361-46.171C46.356,93.935,96.898,44.126,160.284,18.604l25.072,16.774   L238.325,44.206z"
        />
        <polygon
          fill="#03AA6F"
          points="255.982,291.395 247.154,335.536 211.841,370.849 211.841,397.334 176.528,423.818    176.528,467.959 150.044,459.131 132.387,414.99 132.387,326.708 88.246,317.88 70.59,282.567 70.59,256.082 88.246,238.426    114.731,211.941 132.387,247.254 194.184,247.254 220.669,291.395  "
        />
        <path
          fill="#03AA6F"
          d="M479.335,130.987c48.193,85.978,42.702,191.996-14.125,272.526l-23.836-23.836v-35.313   l-17.656-35.313l-17.656-35.313v-35.313l-26.485-17.656l-35.313,8.828l-61.797-26.485l-8.828-61.797l26.485-26.485h52.969   l17.656,26.485l52.969,8.828l52.969-17.656L479.335,130.987z"
        />
      </g>
      <path
        fill="#86DAF1"
        d="M308.951,88.347l35.313-8.828l26.485,8.828l44.141,8.828l26.485-17.656  c14.787,15.476,27.544,32.77,37.961,51.468l-2.648,1.501l-52.969,17.656l-52.969-8.828l-17.656-26.485h-52.969l-26.485,26.485  l8.828,61.797l61.797,26.485l35.313-8.828l26.485,17.656v35.313l17.656,35.313l17.656,35.313v35.313l23.836,23.836  c-81.528,115.526-241.275,143.079-356.792,61.55C10.311,395.815-26.494,267.691,19.916,156.942l15.361,46.171l26.485,17.656  l26.485,17.656L70.59,256.082v26.485l17.656,35.313l44.141,8.828v88.282l17.656,44.141l26.485,8.828v-44.141l35.313-26.485v-26.485  l35.313-35.313l8.828-44.141h-35.313l-26.485-44.141h-61.797l-17.656-35.313l-26.485,26.485v-35.313L70.59,185.457v-26.485  l61.797-8.828l44.141-26.485l26.485-44.141l26.485-8.828l8.828-26.485l-52.969-8.828l-25.072-16.774  c67.889-27.341,144.235-24.322,209.758,8.299l-34.607,17.303h-35.313l-17.656,35.313L308.951,88.347z"
      />
    </svg>
  );
};

export const FactoryIcon = (props) => {
  return (
    <svg id="icon-factory" viewBox="0 0 476.518 476.518">
      <title>factory</title>
      <g>
        <path d="M276.619,38.115c-2.046-3.158-2.703-5.292-2.703-5.292l0.975-0.897c0,0,1.896,0.788,5.21,2.146   c1.564,0.624,3.479,1.39,5.674,2.254c2.162,0.783,4.515,1.696,7.037,2.308c1.242,0.385,2.507,0.768,3.814,0.915   c0.658,0.087,1.285,0.268,1.937,0.388c0.646,0.044,1.294,0.065,1.938,0.147c2.605,0.35,5,0.067,7.626-0.07   c1.218-0.448,2.572-0.574,3.897-1.144c1.214-0.717,2.801-1.133,3.928-2.052c0.597-0.41,1.217-0.837,1.882-1.259   c0.69-0.388,1.424-0.695,2.157-1.488l4.64-3.896c0.044-0.06-0.271,0.399-0.12,0.185l0.032-0.033l0.079-0.07l0.153-0.131   l0.305-0.273l0.612-0.547l1.217-1.067l2.297-2.178c1.444-1.488,3.261-2.648,4.717-4.082c1.434-1.484,3.361-2.392,4.894-3.831   c1.64-1.292,3.557-2.26,5.406-3.513c3.885-1.828,8.425-3.185,12.49-2.615c1.019,0.109,2.009,0.268,2.983,0.448   c0.942,0.262,1.827,0.586,2.703,0.914c1.794,0.592,3.339,1.439,4.795,2.276c2.909,1.681,5.221,3.628,7.069,5.511   c1.837,1.888,3.218,3.727,4.212,5.33c1.042,1.569,1.644,2.955,2.068,3.902c0.351,0.974,0.536,1.499,0.536,1.499l-0.974,0.908   c0,0-2.089-0.706-5.297-2.047c-1.563-0.623-3.459-1.405-5.635-2.281c-2.101-0.865-4.412-1.817-6.853-2.643   c-1.215-0.449-2.472-0.914-3.742-1.221c-0.645-0.158-1.279-0.411-1.927-0.596c-0.646-0.131-1.29-0.296-1.938-0.509   c-2.621-0.854-5.329-1.696-8.682-2.046c-1.54,0.203-3.379,0.137-4.981,0.805c-1.541,0.782-3.311,1.384-4.548,2.774   c-1.247,1.34-2.67,2.512-3.544,4.219l-1.271,2.544l-0.584,1.281l-0.284,0.635l-0.14,0.328l-0.07,0.147l-0.033,0.077l-0.022,0.049   c0.126-0.186-0.196,0.296-0.174,0.268l-2.501,5.516c-0.821,1.779-2.704,3.787-4.241,5.554c-1.56,1.926-3.649,3.032-5.509,4.542   c-1.947,1.368-4.324,2.156-6.5,3.146c-4.631,1.323-9.469,1.56-13.54,0.471c-2.079-0.459-3.992-1.062-5.678-1.937   c-1.765-0.745-3.286-1.674-4.72-2.572c-2.85-1.887-5.109-3.885-6.894-5.844C278.973,41.573,277.622,39.702,276.619,38.115z    M476.518,351.03v113.6H0v-113.6h32.459V223.42l91.47-64.177v64.177l91.456-64.177v64.177l91.475-64.177v126.143h31.56   l17.14-223.139h52.313l15.002,223.139h35.196v65.653h18.446V351.03z M149.375,301.975H77.461v66.387h71.914V301.975z    M273.293,301.975h-71.916v66.387h71.916V301.975z M398.768,301.975h-71.914v66.387h71.914V301.975z" />
      </g>
    </svg>
  );
};

export const TimerIcon = (props) => {
  return (
    <svg id="icon-timer" viewBox="0 0 520 520">
      <title>timer</title>
      <g>
        <path
          fill="#455A64"
          d="M373.333,0H138.667c-17.673,0-32,14.327-32,32s14.327,32,32,32h234.667c17.673,0,32-14.327,32-32   S391.006,0,373.333,0z"
        />
        <path
          fill="#455A64"
          d="M373.333,469.333H138.667c-5.891,0-10.667-4.776-10.667-10.667v-89.28   c-0.001-27.687,11.951-54.026,32.789-72.256l37.824-33.109c4.43-3.883,4.873-10.622,0.99-15.052   c-0.308-0.351-0.639-0.682-0.99-0.99l-37.824-33.109c-20.838-18.23-32.79-44.569-32.789-72.256v-89.28   c0-5.891,4.776-10.667,10.667-10.667h234.667c5.891,0,10.667,4.776,10.667,10.667v89.28c0.001,27.687-11.951,54.026-32.789,72.256   l-37.824,33.109c-4.43,3.883-4.873,10.622-0.99,15.052c0.308,0.351,0.639,0.682,0.99,0.99l37.824,33.109   c20.838,18.23,32.79,44.569,32.789,72.256v89.28C384,464.558,379.224,469.333,373.333,469.333z"
        />
      </g>
      <path
        fill="#ECEFF1"
        d="M149.333,448h213.333v-78.613c-0.026-21.547-9.359-42.033-25.6-56.192l-37.824-33.109  c-13.302-11.636-14.652-31.852-3.016-45.154c0.937-1.071,1.945-2.079,3.016-3.016l37.824-33.109  c16.241-14.159,25.574-34.645,25.6-56.192V64H149.333v78.613c0.026,21.547,9.359,42.033,25.6,56.192l37.824,33.109  c13.296,11.643,14.636,31.86,2.994,45.156c-0.931,1.063-1.931,2.063-2.994,2.994l-37.824,33.131  c-16.241,14.159-25.574,34.645-25.6,56.192V448z"
      />
      <path
        fill="#FFC107"
        d="M319.189,177.259c-1.649-3.989-5.539-6.591-9.856-6.592H202.667  c-5.891-0.011-10.675,4.757-10.686,10.648c-0.005,2.84,1.123,5.565,3.134,7.571l53.333,53.333c4.165,4.164,10.917,4.164,15.083,0  l53.333-53.333C319.92,185.837,320.838,181.248,319.189,177.259z"
      />
      <path
        fill="#455A64"
        d="M373.333,448H138.667c-17.673,0-32,14.327-32,32s14.327,32,32,32h234.667c17.673,0,32-14.327,32-32  S391.006,448,373.333,448z"
      />
      <path
        fill="#FFC107"
        d="M263.168,333.44c-4.214-3.815-10.678-3.655-14.699,0.363l-99.136,99.115V448h213.333v-24.107  L263.168,333.44z"
      />
    </svg>
  );
};

export const EditIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      id="icon-clipboard-edit1"
      viewBox="0 0 32 32"
      width={width}
      height={height}
    >
      <path d="M26.443 13.15l-2.6-2.6-11.292 11.294 2.606 2.606 11.286-11.3zM27.15 12.443l1.729-1.731c0.39-0.39 0.387-1.025-0.005-1.416l-1.18-1.177c-0.393-0.392-1.025-0.395-1.417-0.003l-1.727 1.728 2.599 2.599zM11.904 22.611l-0.64 3.113 3.135-0.617-2.495-2.495zM22 19v9.996c0 1.114-0.894 2.004-1.997 2.004h-15.005c-1.107 0-1.997-0.897-1.997-2.004v-20.993c0-1.114 0.894-2.004 1.997-2.004h1.003c0.003-1.109 0.898-2 2.003-2h0.997c0.001-1.662 1.348-3 3.009-3h0.982c1.659 0 3.008 1.343 3.009 3h0.997c1.108 0 2 0.895 2.003 2v0h1.003c1.107 0 1.997 0.897 1.997 2.004v2.996l3.58-3.58c0.793-0.793 2.051-0.788 2.83-0.010l1.18 1.179c0.776 0.776 0.775 2.046-0.010 2.83l-7.58 7.58zM21 12v-3.997c0-0.554-0.455-1.003-1-1.003h-1c-0.003 1.109-0.898 2-2.003 2h-8.994c-1.108 0-2-0.895-2.003-2h-1c-0.552 0-1 0.439-1 1.003v20.994c0 0.554 0.455 1.003 1 1.003h15c0.552 0 1-0.439 1-1.003v-8.997l-6 6-5 1 1-5 10-10zM10 5h-2.004c-0.55 0-0.996 0.443-0.996 0.999v1.002c0 0.552 0.445 0.999 0.996 0.999h9.009c0.55 0 0.996-0.443 0.996-0.999v-1.002c0-0.552-0.445-0.999-0.996-0.999h-2.004v-1.002c0-1.103-0.894-1.998-2.005-1.998h-0.99c-1.107 0-2.005 0.898-2.005 1.998v1.002zM12.5 5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5v0 0z"></path>
    </svg>
  );
};

export const AlertIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      id="icon-alert"
      // viewBox="0 0 32 32"
      width={width}
      height={height}
    >
      <path d="M 12.5 18.75 L 7.5 18.75 L 7.5 15 L 12.5 15 Z M 11.875 12.5 L 8.125 12.5 L 7.5 1.25 L 12.5 1.25 Z M 11.875 12.5 "></path>
    </svg>
  );
};

export const DeleteIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg id="icon-bin" viewBox="0 0 32 32" width={width} height={height}>
      <path d="M4 10v20c0 1.1 0.9 2 2 2h18c1.1 0 2-0.9 2-2v-20h-22zM10 28h-2v-14h2v14zM14 28h-2v-14h2v14zM18 28h-2v-14h2v14zM22 28h-2v-14h2v14z"></path>
      <path d="M26.5 4h-6.5v-2.5c0-0.825-0.675-1.5-1.5-1.5h-7c-0.825 0-1.5 0.675-1.5 1.5v2.5h-6.5c-0.825 0-1.5 0.675-1.5 1.5v2.5h26v-2.5c0-0.825-0.675-1.5-1.5-1.5zM18 4h-6v-1.975h6v1.975z"></path>
    </svg>
  );
};

export const UploadIcon = (props) => {
  const { width = 25, height = 20 } = props;
  return (
    <svg id="icon-upload" viewBox="0 0 32 32" width={width} height={height}>
      <g>
        <path d="M 13.011719 4.605469 C 8.636719 9.554688 8.40625 10.363281 11.398438 10.363281 C 13.238281 10.363281 13.699219 11.28125 14.046875 15.199219 C 14.390625 19.574219 14.738281 20.148438 17.269531 20.148438 C 19.800781 20.148438 20.148438 19.574219 20.492188 15.199219 C 20.839844 11.28125 21.300781 10.363281 23.140625 10.363281 C 26.363281 10.363281 25.90625 9.09375 21.070312 4.488281 L 16.695312 0.34375 Z M 13.011719 4.605469 " />
        <path d="M 2.648438 22.335938 C -0.230469 24.867188 -0.34375 25.445312 0.574219 29.472656 L 1.726562 33.964844 L 32.8125 33.964844 L 33.964844 29.472656 C 34.886719 25.445312 34.769531 24.867188 31.890625 22.335938 C 30.050781 20.839844 27.746094 19.574219 26.710938 19.574219 C 25.214844 19.574219 25.328125 20.148438 27.632812 21.875 L 30.511719 24.175781 L 27.285156 24.175781 C 24.984375 24.175781 23.832031 24.867188 23.371094 26.480469 C 22.910156 28.324219 21.761719 28.78125 17.269531 28.78125 C 12.78125 28.78125 11.628906 28.324219 11.167969 26.480469 C 10.707031 24.867188 9.554688 24.175781 7.253906 24.175781 L 4.03125 24.175781 L 6.90625 21.875 C 9.210938 20.148438 9.324219 19.574219 7.828125 19.574219 C 6.792969 19.574219 4.488281 20.839844 2.648438 22.335938 Z M 2.648438 22.335938 " />
      </g>
    </svg>
  );
};

export const ParameterIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg viewBox="0 0 32 32" width={width} height={height}>
      <g id="settings_2_">
        <path
          clipRule="evenodd"
          d="M8,6.021V3c0-1.654-1.346-3-3-3S2,1.346,2,3v3.021   C0.792,6.936,0,8.369,0,10s0.792,3.064,2,3.977V29c0,1.654,1.346,3,3,3s3-1.346,3-3V13.977c1.208-0.912,2-2.346,2-3.977   S9.208,6.936,8,6.021z M4,3c0-0.553,0.447-1,1-1s1,0.447,1,1v2.1C5.677,5.035,5.343,5,5,5S4.323,5.035,4,5.1V3z M6,29   c0,0.553-0.447,1-1,1s-1-0.447-1-1V14.898C4.323,14.965,4.657,15,5,15s0.677-0.035,1-0.102V29z M7.865,10.84   c-0.016,0.053-0.03,0.105-0.049,0.158c-0.095,0.264-0.217,0.514-0.378,0.736c-0.004,0.006-0.01,0.01-0.014,0.016   c-0.174,0.238-0.381,0.449-0.616,0.627c-0.004,0.004-0.007,0.006-0.01,0.008c-0.241,0.182-0.51,0.328-0.799,0.43   C5.686,12.928,5.353,13,5,13s-0.686-0.072-1-0.186c-0.289-0.102-0.558-0.248-0.799-0.43c-0.003-0.002-0.006-0.004-0.01-0.008   c-0.235-0.178-0.442-0.389-0.616-0.627c-0.004-0.006-0.01-0.01-0.014-0.016c-0.161-0.223-0.283-0.473-0.378-0.736   c-0.019-0.053-0.033-0.105-0.049-0.158C2.055,10.572,2,10.293,2,10c0-0.295,0.055-0.574,0.135-0.842   c0.016-0.053,0.03-0.105,0.049-0.156C2.278,8.738,2.4,8.488,2.562,8.264c0.004-0.006,0.01-0.01,0.014-0.016   c0.174-0.236,0.381-0.449,0.616-0.627c0.004-0.002,0.007-0.006,0.01-0.008C3.442,7.434,3.711,7.287,4,7.184   C4.314,7.072,4.647,7,5,7s0.686,0.072,1,0.184c0.289,0.104,0.558,0.25,0.799,0.43c0.003,0.002,0.006,0.006,0.01,0.008   c0.235,0.178,0.442,0.391,0.616,0.627c0.004,0.006,0.01,0.01,0.014,0.016C7.6,8.488,7.722,8.738,7.816,9.002   C7.835,9.053,7.85,9.105,7.865,9.158C7.945,9.426,8,9.705,8,10C8,10.293,7.945,10.572,7.865,10.84z"
          fill="#333333"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M30,6.021V3c0-1.654-1.346-3-3-3s-3,1.346-3,3v3.021   C22.791,6.936,22,8.369,22,10s0.791,3.064,2,3.977V29c0,1.654,1.346,3,3,3s3-1.346,3-3V13.977c1.207-0.912,2-2.346,2-3.977   S31.207,6.936,30,6.021z M26,3c0-0.553,0.447-1,1-1s1,0.447,1,1v2.1C27.676,5.035,27.342,5,27,5c-0.344,0-0.678,0.035-1,0.1V3z    M28,29c0,0.553-0.447,1-1,1s-1-0.447-1-1V14.898C26.322,14.965,26.656,15,27,15c0.342,0,0.676-0.035,1-0.102V29z M29.865,10.84   c-0.016,0.053-0.031,0.105-0.049,0.158c-0.096,0.264-0.217,0.514-0.379,0.736c-0.004,0.006-0.01,0.01-0.014,0.016   c-0.174,0.238-0.381,0.449-0.615,0.627c-0.004,0.004-0.008,0.006-0.01,0.008c-0.242,0.182-0.51,0.328-0.799,0.43   C27.686,12.928,27.352,13,27,13c-0.354,0-0.686-0.072-1-0.186c-0.289-0.102-0.559-0.248-0.799-0.43   c-0.004-0.002-0.006-0.004-0.01-0.008c-0.236-0.178-0.443-0.389-0.617-0.627c-0.004-0.006-0.01-0.01-0.014-0.016   c-0.16-0.223-0.283-0.473-0.377-0.736c-0.02-0.053-0.033-0.105-0.049-0.158C24.055,10.572,24,10.293,24,10   c0-0.295,0.055-0.574,0.135-0.842c0.016-0.053,0.029-0.105,0.049-0.156c0.094-0.264,0.217-0.514,0.377-0.738   c0.004-0.006,0.01-0.01,0.014-0.016c0.174-0.236,0.381-0.449,0.617-0.627c0.004-0.002,0.006-0.006,0.01-0.008   c0.24-0.18,0.51-0.326,0.799-0.43C26.314,7.072,26.646,7,27,7c0.352,0,0.686,0.072,1,0.184c0.289,0.104,0.557,0.25,0.799,0.43   c0.002,0.002,0.006,0.006,0.01,0.008c0.234,0.178,0.441,0.391,0.615,0.627c0.004,0.006,0.01,0.01,0.014,0.016   c0.162,0.225,0.283,0.475,0.379,0.738c0.018,0.051,0.033,0.104,0.049,0.156C29.945,9.426,30,9.705,30,10   C30,10.293,29.945,10.572,29.865,10.84z"
          fill="#333333"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M19,18.021V3c0-1.654-1.346-3-3-3s-3,1.346-3,3v15.021   c-1.208,0.914-2,2.348-2,3.979s0.792,3.064,2,3.977V29c0,1.654,1.346,3,3,3s3-1.346,3-3v-3.023c1.207-0.912,2-2.346,2-3.977   S20.207,18.936,19,18.021z M15,3c0-0.553,0.447-1,1-1c0.553,0,1,0.447,1,1v14.1c-0.324-0.064-0.658-0.1-1-0.1   c-0.343,0-0.677,0.035-1,0.1V3z M17,29c0,0.553-0.447,1-1,1c-0.553,0-1-0.447-1-1v-2.102C15.323,26.965,15.657,27,16,27   c0.342,0,0.676-0.035,1-0.102V29z M18.865,22.84c-0.016,0.053-0.031,0.105-0.049,0.158c-0.096,0.264-0.217,0.514-0.379,0.736   c-0.004,0.006-0.01,0.01-0.014,0.016c-0.174,0.238-0.381,0.449-0.615,0.627c-0.004,0.004-0.008,0.006-0.01,0.008   c-0.242,0.182-0.51,0.328-0.799,0.43C16.686,24.928,16.352,25,16,25c-0.353,0-0.686-0.072-1-0.186   c-0.289-0.102-0.558-0.248-0.799-0.43c-0.003-0.002-0.006-0.004-0.01-0.008c-0.235-0.178-0.442-0.389-0.616-0.627   c-0.004-0.006-0.01-0.01-0.014-0.016c-0.161-0.223-0.283-0.473-0.378-0.736c-0.019-0.053-0.033-0.105-0.049-0.158   C13.055,22.572,13,22.293,13,22c0-0.295,0.055-0.574,0.135-0.842c0.016-0.053,0.03-0.105,0.049-0.156   c0.095-0.264,0.217-0.514,0.378-0.738c0.004-0.006,0.01-0.01,0.014-0.016c0.174-0.236,0.381-0.449,0.616-0.627   c0.004-0.002,0.007-0.006,0.01-0.008c0.241-0.18,0.51-0.326,0.799-0.43C15.314,19.072,15.647,19,16,19c0.352,0,0.686,0.072,1,0.184   c0.289,0.104,0.557,0.25,0.799,0.43c0.002,0.002,0.006,0.006,0.01,0.008c0.234,0.178,0.441,0.391,0.615,0.627   c0.004,0.006,0.01,0.01,0.014,0.016c0.162,0.225,0.283,0.475,0.379,0.738c0.018,0.051,0.033,0.104,0.049,0.156   C18.945,21.426,19,21.705,19,22C19,22.293,18.945,22.572,18.865,22.84z"
          fill="#333333"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const PermissionIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 1000 1000">
      <metadata>Svg Vector Icons : http://www.onlinewebfonts.com/icon</metadata>
      <g>
        <path d="M933.1,499.5c85.1-121.6,73.5-290.3-35-398.9c-121.8-121.7-319.2-121.7-441,0c-80.5,80.5-107.4,194-81.5,296.9l-98.3,98.3v33.7v44.6h-89.1v89.1l-89-0.1v89.1l-89.1,0v44.5l0,175.4v0.1v0.8h252l143.4-143.4c53.1,95.9,155.3,160.9,272.8,160.9C850.4,990.6,990,851,990,678.8C990,612,968.8,550.3,933.1,499.5z M243,930.4l-87.8,0l213.6-213.6c3,24.5,8.9,48,17.2,70.5L243,930.4z M366.4,678.8c0,2.9,0.4,5.7,0.4,8.6L123.7,930.4l-69.2,0l0-133.7l89.1,0v-89.1h89.1v-89h89.1V514.2l104.4-104.4c-0.3-0.9-0.9-2.1-1.5-3.3c-31.4-93.2-10.4-200.1,63.9-274.4c104.4-104.4,273.6-104.4,378,0c89.8,89.8,100.2,226.6,35.4,329.7c-38.4-39.6-87.3-68.9-142.2-83.8c29.3-39,26.6-94.7-8.9-130.2c-38.9-38.9-102.2-38.9-141.1,0c-35.2,35.2-38.2,90.3-9.7,129.3C465.7,412,366.4,533.6,366.4,678.8z M732.7,370.9c-0.4,0.4-0.9,0.6-1.2,0.9c-17.4-3-35.1-4.9-53.3-4.9c-17,0-33.6,1.7-49.9,4.4c-0.1-0.1-0.4-0.2-0.5-0.4c-29-29-29-76,0-104.9c29-28.9,76-28.9,105,0C761.7,295,761.7,341.9,732.7,370.9z M678.2,946.1c-147.6,0-267.3-119.6-267.3-267.3s119.7-267.3,267.3-267.3c147.6,0,267.3,119.6,267.3,267.3S825.8,946.1,678.2,946.1z" />
        <path d="M867.7,556.3l-252,252l-126-126l-31.5,31.5l157.5,157.5l0,0l283.4-283.4L867.7,556.3z" />
      </g>
    </svg>
  );
};

export const DashboardIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-layout-dashboard"
    >
      <rect width="7" height="9" x="3" y="3" rx="1" />
      <rect width="7" height="5" x="14" y="3" rx="1" />
      <rect width="7" height="9" x="14" y="12" rx="1" />
      <rect width="7" height="5" x="3" y="16" rx="1" />
    </svg>
  );
};
export const ReportsIcon2 = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-scroll-text"
    >
      <path d="M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
      <path d="M15 8h-5" />
      <path d="M15 12h-5" />
    </svg>
  );
};
export const AlertsIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-bell-ring"
    >
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
      <path d="M4 2C2.8 3.7 2 5.7 2 8" />
      <path d="M22 8c0-2.3-.8-4.3-2-6" />
    </svg>
  );
};
export const ProfileIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-circle-user-round"
    >
      <path d="M18 20a6 6 0 0 0-12 0" />
      <circle cx="12" cy="10" r="4" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
};
export const TransIcon = (props) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-bar-chart-big"
    >
      <path d="M3 3v18h18" />
      <rect width="4" height="7" x="7" y="10" rx="1" />
      <rect width="4" height="12" x="15" y="5" rx="1" />
    </svg>
  );
};


export const SettingsIcon = (props) => {
  const { width = 32, height = 32 } = props;
  return (
    <svg
      id="icon-cog"
      className="fill-light-black"
      viewBox="0 0 32 32"
      width={width}
      height={height}
    >
      <title>Settings</title>

      <path d="M29.181 19.070c-1.679-2.908-0.669-6.634 2.255-8.328l-3.145-5.447c-0.898 0.527-1.943 0.829-3.058 0.829-3.361 0-6.085-2.742-6.085-6.125h-6.289c0.008 1.044-0.252 2.103-0.811 3.070-1.679 2.908-5.411 3.897-8.339 2.211l-3.144 5.447c0.905 0.515 1.689 1.268 2.246 2.234 1.676 2.903 0.672 6.623-2.241 8.319l3.145 5.447c0.895-0.522 1.935-0.82 3.044-0.82 3.35 0 6.067 2.725 6.084 6.092h6.289c-0.003-1.034 0.259-2.080 0.811-3.038 1.676-2.903 5.399-3.894 8.325-2.219l3.145-5.447c-0.899-0.515-1.678-1.266-2.232-2.226zM16 22.479c-3.578 0-6.479-2.901-6.479-6.479s2.901-6.479 6.479-6.479c3.578 0 6.479 2.901 6.479 6.479s-2.901 6.479-6.479 6.479z"></path>
    </svg>
  );
};
